export { default } from './CardDetails';
